import { NICHES } from '../constants';

/**
 * Categorizes a custom niche string into one of the predefined NICHES.
 * This is a simple keyword-based mapping.
 */
export function categorizeNiche(input: string): string {
  const lowerInput = input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  
  if (NICHES.includes(input)) return input;

  // Keyword mapping
  if (lowerInput.includes('bolo') || lowerInput.includes('boleir') || lowerInput.includes('doce') || lowerInput.includes('comida') || lowerInput.includes('marmita') || lowerInput.includes('salgad') || lowerInput.includes('padr') || lowerInput.includes('gastronom') || lowerInput.includes('sorvet') || lowerInput.includes('acai') || lowerInput.includes('gelat') || lowerInput.includes('picole') || lowerInput.includes('padaria') || lowerInput.includes('panific')) {
    return NICHES[1]; // Alimentação e Confeitaria
  }
  if (lowerInput.includes('cabelo') || lowerInput.includes('unha') || lowerInput.includes('massagem') || lowerInput.includes('estética') || lowerInput.includes('maquiagem')) {
    return NICHES[2]; // Beleza e Estética
  }
  if (lowerInput.includes('pedreiro') || lowerInput.includes('pintor') || lowerInput.includes('reforma') || lowerInput.includes('obra')) {
    return NICHES[3]; // Obras e Reformas
  }
  if (lowerInput.includes('eletrica') || lowerInput.includes('encanador') || lowerInput.includes('reparo') || lowerInput.includes('manutenção residencial')) {
    return NICHES[4]; // Instalações e Reparos
  }
  if (lowerInput.includes('mecânica') || lowerInput.includes('oficina') || lowerInput.includes('pneu') || lowerInput.includes('automóvel') || lowerInput.includes('detalham')) {
    return NICHES[5]; // Serviços Automotivos
  }
  if (lowerInput.includes('costura') || lowerInput.includes('roupa') || lowerInput.includes('moda') || lowerInput.includes('ajuste')) {
    return NICHES[6]; // Moda e Costura
  }
  if (lowerInput.includes('festa') || lowerInput.includes('evento') || lowerInput.includes('dj') || lowerInput.includes('buffet')) {
    return NICHES[7]; // Eventos e Festas
  }
  if (lowerInput.includes('limpeza') || lowerInput.includes('faxina') || lowerInput.includes('higienização') || lowerInput.includes('sofa')) {
    return NICHES[8]; // Limpeza e Higienização
  }
  if (lowerInput.includes('design') || lowerInput.includes('tecnologia') || lowerInput.includes('social media') || lowerInput.includes('programador') || lowerInput.includes('marketing')) {
    return NICHES[9]; // Serviços Criativos e Tecnologia
  }
  if (lowerInput.includes('aula') || lowerInput.includes('consultoria') || lowerInput.includes('curso') || lowerInput.includes('professor') || lowerInput.includes(' coach ')) {
    return NICHES[10]; // Educação e Consultoria
  }
  if (lowerInput.includes('artesanato') || lowerInput.includes('manual') || lowerInput.includes('biscuit')) {
    return NICHES[11]; // Artesanato e Manuais
  }
  if (lowerInput.includes('entrega') || lowerInput.includes('frete') || lowerInput.includes('locação') || lowerInput.includes('mudança')) {
    return NICHES[12]; // Logística, Entregas e Locação
  }
  if (lowerInput.includes('pet') || lowerInput.includes('banho e tosa') || lowerInput.includes('cachorro') || lowerInput.includes('gato') || lowerInput.includes('veterin')) {
    return NICHES[13]; // Serviços Pet
  }
  if (
    lowerInput.includes('venda') || 
    lowerInput.includes('revenda') || 
    lowerInput.includes('loja') || 
    lowerInput.includes('mercadoria') || 
    lowerInput.includes('brechó') || 
    lowerInput.includes('brecho') || 
    lowerInput.includes('boutique') || 
    lowerInput.includes('roupa') || 
    lowerInput.includes('moda') ||
    lowerInput.includes('agro') ||
    lowerInput.includes('racao') ||
    lowerInput.includes('emporio') ||
    lowerInput.includes('granel') ||
    lowerInput.includes('graos') ||
    lowerInput.includes('hortifruti') ||
    lowerInput.includes('sacolao') ||
    lowerInput.includes('quitanda') ||
    lowerInput.includes('acougue') ||
    lowerInput.includes('carne') ||
    lowerInput.includes('mercearia') ||
    lowerInput.includes('mercado') ||
    lowerInput.includes('armazem')
  ) {
    return NICHES[14]; // Varejo e Revenda
  }
  if (lowerInput.includes('doméstica') || lowerInput.includes('domestica') || lowerInput.includes('babá') || lowerInput.includes('baba') || lowerInput.includes('cuidador') || lowerInput.includes('passadeira') || lowerInput.includes('organizer')) {
    return NICHES[15]; // Serviços Domésticos
  }
  if (lowerInput.includes('gráfica') || lowerInput.includes('grafica') || lowerInput.includes('impressão') || lowerInput.includes('papelaria') || lowerInput.includes('brinde') || lowerInput.includes('laser') || lowerInput.includes('3d')) {
    return NICHES[16]; // Gráfica e Personalização
  }
  if (lowerInput.includes('vestuário') || lowerInput.includes('estamparia') || lowerInput.includes('bordado') || lowerInput.includes('camisa') || lowerInput.includes('têxtil') || lowerInput.includes('textil')) {
    return NICHES[17]; // Vestuário e Têxtil
  }
  if (lowerInput.includes('resina') || lowerInput.includes('marcenaria criativa') || lowerInput.includes('patchwork') || lowerInput.includes('mdf')) {
    return NICHES[18]; // Artesanato e Produção Manual
  }

  // Default to a generic one if no match
  return NICHES[0]; // Pessoa Física e Autônomo
}

/**
 * Retorna o tipo de template (FOOD, TECHNICAL, STANDARD) com base no nome do nicho.
 */
export function getTemplateTypeByNiche(niche: string): 'FOOD' | 'TECHNICAL' | 'STANDARD' | null {
  if (!niche) return null;

  const lowerNiche = niche.toLowerCase();

  // FOOD: Alimentação e Confeitaria
  if (lowerNiche.includes('alimentação') || lowerNiche.includes('confeitaria')) {
    return 'FOOD';
  }

  // TECHNICAL: Obras, Mecânica, TI, Reparos
  if (
    lowerNiche.includes('obra') || 
    lowerNiche.includes('reforma') || 
    lowerNiche.includes('instalação') || 
    lowerNiche.includes('reparo') || 
    lowerNiche.includes('mecânica') || 
    lowerNiche.includes('automotivo') || 
    lowerNiche.includes('tecnologia') || 
    lowerNiche.includes('ti') ||
    lowerNiche.includes('gráfica')
  ) {
    return 'TECHNICAL';
  }

  // DEFAULT: Todos os outros (incluindo Artesanato, Moda, Eventos, etc)
  return 'STANDARD';
}

